import { styled } from '@mui/material';
import Box from '@mui/material/Box';

export const StyledBorderBox = styled(Box)(({ theme }) => ({
    backgroundColor: theme.palette.background.paper,
    border: theme.constants.border,
    borderRadius: theme.constants.borderRadius,
}));

export const StyledBorderBoxHeader = styled(Box)(({ theme }) => ({
    ...theme.typography.flexAlignCenter,
    gap: theme.spacing(1.5),
    padding: theme.spacing(2),
}));

export const StyledBorderBoxHeaderColumn = styled(Box)(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    flexGrow: 1,
    gap: theme.spacing(0.5),
    justifyContent: 'flex-start',
}));

export const StyledBorderBoxHeaderRow = styled(Box)(({ theme }) => ({
    ...theme.typography.flexAlignCenter,
    flex: '100%',
    gap: theme.spacing(1),
    justifyContent: 'space-between',
}));

export const StyledBorderBoxTitleContainer = styled(Box)(({ theme }) => ({
    ...theme.typography.flexAlignCenter,
    gap: theme.spacing(1.5),
}));

export const StyledBorderBoxHeaderActions = styled(Box)(({ theme }) => ({
    ...theme.typography.flexAlignCenter,
    gap: theme.spacing(1),
}));

export const StyledBorderBoxContent = styled(Box)<{ gap?: number }>(({ theme, gap = 2 }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(gap),
    padding: theme.spacing(2),
    // TODO: Get rid
    '& .MuiFormControl-root': {
        margin: 0,
    },
}));

export const StyledBorderBoxContentGrey = styled(StyledBorderBoxContent)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'light' ? theme.palette.grey[50] : theme.palette.grey[900],
}));

export const StyledBorderBoxMainActions = styled(Box)(({ theme }) => ({
    ...theme.typography.flexAlignCenter,
    gap: theme.spacing(2),
    justifyContent: 'flex-end',
    padding: theme.spacing(2),
}));

export const StyledBorderBoxMainActionsLeftButtonContainer = styled(Box)(({ theme }) => ({
    ...theme.typography.flexAlignCenter,
    flexGrow: 1,
    gap: theme.spacing(1),
    justifyContent: 'flex-start',
}));
